import { mapState } from "vuex";
import { StatusTypes, StatusChange, StatusList } from "@/utils/status";

export default {
  data() {
    return {
      timeObject: [
        ["hour", 3600],
        ["minute", 60],
        ["seconds", 1]
      ]
    };
  },
  computed: {
    ...mapState("auth", ["user"]),
    ...mapState("equipments", ["equipmentProfile"]),
    ...mapState("reliabilities", ["lastReliability"]),
    list() {
      return new StatusList(
        this.equipmentProfile?.reliability?.list.map(
          item =>
            new StatusChange(item.name, new Date(item.date.seconds * 1000))
        )
      );
    },
    lastDateAgo() {
      const date =
        this.lastReliability[0]?.datetime?.toDate() ||
        this.list.list[this.list.list.length - 1].date;

      const actualDate = new Date();
      const miliseconds = +actualDate - +date;
      const timeObject = [
        ["year", 31536000],
        ["month", 2592000],
        ["day", 86400],
        ["hour", 3600],
        ["minute", 60],
        ["second", 1]
      ];

      const lang = this.user.language ? this.user.language : "en";
      const rtf = new Intl.RelativeTimeFormat(lang);

      const seconds = miliseconds / 1000;
      let timeago;

      for (const [unit, value] of timeObject) {
        if (seconds > value || unit === "seconds") {
          timeago = -Math.floor(parseFloat(seconds / +value));
          return `${rtf.format(timeago, unit)}`;
        }
      }
    },
    running() {
      //return this.equipmentProfile?.reliability?.uptime;
      return this.list?.meanTime(StatusTypes.uptime);
    },
    maintenance() {
      //return this.equipmentProfile?.reliability?.maintenance;
      return this.list?.meanTime(StatusTypes.maintenance);
    },
    standBy() {
      //return this.equipmentProfile?.reliability?.standBy;
      return this.list?.meanTime(StatusTypes.standBy);
    },
    failure() {
      //return this.equipmentProfile?.reliability?.failure;
      return this.list?.meanTime(StatusTypes.failure);
    },
    totalFailures() {
      return this.equipmentProfile?.reliability?.totalFailures;
    },
    totalDownTime() {
      return (
        this.standBy?.totalTimeInHours +
        this.maintenance?.totalTimeInHours +
        this.failure?.totalTimeInHours
      ).toFixed(2);
    },
    mechanicalAvailability() {
      let calendarTime;
      calendarTime =
        this.running?.totalTimeInHours +
        this.maintenance?.totalTimeInHours +
        this.failure?.totalTimeInHours;
      let result = (this.running?.totalTimeInHours / calendarTime) * 100;
      return `${result.toFixed(2)} %`;
    },
    utilizationTime() {
      let availableTime;
      availableTime =
        this.running?.totalTimeInHours + this.standBy?.totalTimeInHours;
      let result =
        ((availableTime - this.standBy?.totalTimeInHours) / availableTime) *
        100;
      return `${result.toFixed(2)} %`;
    }
  },
  methods: {
    translateTimeObject(time, unit) {
      const dictionary = `dashboard.${unit}`;
      return `${time} ${this.$t(dictionary)}`;
    },
    consolethis(some) {
      console.log(some);
    }
  }
};
